import { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";

export default function NewsletterForm({ source = "site" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email.trim(), source);
      toast.success(res.message || "Subscribed");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} data-testid={`newsletter-form-${source}`} className="flex gap-2">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@creator.com"
        data-testid={`newsletter-input-${source}`}
        className="flex-1 min-w-0 bg-[#1A1D25] border border-[#272B36] focus:border-[#D9B36C] outline-none rounded-full px-4 py-2.5 text-sm text-white placeholder:text-slate-500 transition-colors"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`newsletter-submit-${source}`}
        className="bg-white text-black font-semibold px-4 py-2.5 rounded-full text-sm hover:bg-[#D9B36C] transition-colors disabled:opacity-50 whitespace-nowrap"
      >
        {loading ? "…" : "Subscribe"}
      </button>
    </form>
  );
}
